function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Header from "./Header";
import PanelSideContext from "./PanelSideContext";
const Container = styled.div.withConfig({
  componentId: "sc-18eschf-0"
})(["position:relative;", ";display:grid;overflow:hidden;grid-template-areas:\"header header header\" \"start main end\";grid-template-rows:auto 1fr;grid-template-columns:auto 1fr auto;"], _ref => {
  let {
    stickyHeader
  } = _ref;
  return stickyHeader ? "height: 100vh" : "min-height: 100vh";
});
const Main = styled.div.withConfig({
  componentId: "sc-18eschf-1"
})(["position:relative;grid-area:main;max-width:100vw;", ""], _ref2 => {
  let {
    stickyHeader
  } = _ref2;
  return stickyHeader ? "overflow: auto;" : "";
});

const SidePanels = _ref3 => {
  let {
    children,
    header,
    startPanel,
    endPanel,
    stickyHeader,
    ...rest
  } = _ref3;
  return /*#__PURE__*/React.createElement(Container, _extends({
    stickyHeader: stickyHeader
  }, rest), header ? /*#__PURE__*/React.createElement(Header, null, header) : null, startPanel ? /*#__PURE__*/React.createElement(PanelSideContext.Provider, {
    value: "start"
  }, startPanel) : null, endPanel ? /*#__PURE__*/React.createElement(PanelSideContext.Provider, {
    value: "end"
  }, endPanel) : null, /*#__PURE__*/React.createElement(Main, {
    stickyHeader: stickyHeader
  }, children));
};

SidePanels.propTypes = {
  /** Main content between the side panel(s) */
  children: PropTypes.node.isRequired,

  /** Header above the side panel(s) */
  header: PropTypes.node,

  /** Panel component for the start side */
  startPanel: PropTypes.node,

  /** Panel component for the end side */
  endPanel: PropTypes.node,

  /** Determines if side panel takes up viewport or overflows  */
  stickyHeader: PropTypes.bool
};
export default SidePanels;